// Input only type ...
export enum TagGroupAutoTypeGq {
  STANDALONE_WORDS = 'STANDALONE_WORDS',
  ANYWHERE = 'ANYWHERE',
  EXACT_KEYWORD = 'EXACT_KEYWORD',
}
